import jsPDF from "jspdf";
import {ToBritishDate} from "../utilities/ToMySqlDate";
import {autoTable} from 'jspdf-autotable'
// ... existing code ...
import {numberWithCommas, printFormatNumber, sF} from "../utilities/NumberFormatter";

export function LedgerPrint(body, name, customerName, dateRange) {
    let bList = []
    let totalDebit = 0;
    let totalCredit = 0;
    const initialBalance = sF(body[0].total) + sF(body[0].credit) - sF(body[0].debit);
    body.forEach(element => {
        const b = [
            element.date,
            element.invoiceId,
            customerName === "CASH" || customerName === "CHEQUE" || customerName === "VOUCHER" ? element.customerName : element.mode,
            printFormatNumber(element.debit),
            printFormatNumber(element.credit),
            printFormatNumber(element.total),
            element.department,
            element.comments
        ]
        totalDebit += element.debit === "" ? 0 : sF(element.debit);
        totalCredit += element.credit === "" ? 0 : sF(element.credit);
        bList = [...bList, b]
    })

    const doc = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: "a4",
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // Tracking for page-wise totals
    let pageDebit = 0;
    let pageCredit = 0;

    autoTable(doc, {
        head: [['Date', 'Folio', customerName === "CASH" || customerName === "CHEQUE" || customerName === "VOUCHER" ? 'Customer' : 'Mode', 'Debit', 'Credit', 'Total', 'Dept', 'Comment']],
        body: bList,
        startY: 70,
        theme: 'striped',

        // Make rows as short as possible:
        // - remove vertical padding
        // - avoid text wrapping (wrapping forces taller rows)
        // - avoid any minimum cell height
        styles: {
            fontSize: 9,
            cellPadding: { top: 0, right: 1, bottom: 0, left: 1 },
            minCellHeight: 0,
            overflow: 'ellipsize',
            valign: 'middle',
            textColor: [0, 0, 0],
            lineColor: [0, 0, 0],
            lineWidth: 0
        },
        bodyStyles: {
            textColor: [0, 0, 0],
            fontStyle: 'bold'
        },

        headStyles: {
            fillColor: [41, 128, 185],
            textColor: 255,
            fontSize: 9,
            fontStyle: 'bold',
            halign: 'center',
            cellPadding: { top: 0, right: 1, bottom: 0, left: 1 },
            minCellHeight: 0,
            overflow: 'ellipsize',
            valign: 'middle'
        },
        didDrawPage: (data) => {
            // --- Header ---
            doc.setFontSize(14);
            doc.setTextColor(0); // <-- black (darker than 40)
            doc.text(name, 20, 30);

            doc.setFontSize(10);
            doc.setTextColor(0); // <-- keep header black too
            doc.text("Ledger Report", pageWidth - 20, 30, { align: 'right' });

            doc.setFontSize(8);
            doc.setTextColor(0); // <-- black
            doc.text(`Customer: ${customerName}`, 20, 45);
            doc.text(`Period: ${dateRange}`, 20, 55);
            doc.text(`Opening Balance: ${printFormatNumber(numberWithCommas(initialBalance.toFixed(2)))}`, pageWidth - 20, 45, { align: 'right' });

            // --- Footer (Replacing afterPageContent) ---
            doc.setFontSize(8);
            doc.setFont(undefined, 'bold');
            doc.setTextColor(0);
            const footerY = pageHeight - 25;

            const formattedDebit = printFormatNumber(pageDebit.toFixed(2).toString());
            const formattedCredit = printFormatNumber(pageCredit.toFixed(2).toString());

            doc.setDrawColor(0); // <-- black line
            doc.line(20, footerY - 10, pageWidth - 20, footerY - 10);
            doc.text(
                `Page Total - Debit: ${formattedDebit}   Credit: ${formattedCredit}`,
                pageWidth - 20,
                footerY,
                { align: 'right' }
            );

            // Reset page totals AFTER drawing the footer for the current page
            pageDebit = 0;
            pageCredit = 0;
        },
        didDrawCell: (data) => {
            if (data.section === 'body') {
                // Use a more robust check for the raw value
                const rawVal = data.cell.raw ? String(data.cell.raw).replace(/,/g, '') : '0';
                if (data.column.index === 3) pageDebit += sF(rawVal);
                if (data.column.index === 4) pageCredit += sF(rawVal);
            }
        },
        willDrawCell: (data) => {
            // Add page totals at the bottom of each page
            if (data.section === 'body' && data.row.index === data.table.body.length - 1) {
                // This is handled by draw page usually, but for specific page sums:
            }
        },
        alternateRowStyles: {
            fillColor: [245, 248, 250]
        },
        columnStyles: {
            0: { halign: 'left', cellWidth: 45 },
            1: { halign: 'center', cellWidth: 35 },
            2: { halign: 'left' },
            3: { halign: 'right', cellWidth: 50 },
            4: { halign: 'right', cellWidth: 50 },
            5: { halign: 'right', cellWidth: 50 },
            6: { halign: 'left', cellWidth: 40 },
            7: { halign: 'left' }
        },
        margin: { top: 70, bottom: 40, left: 20, right: 20 },
    });

    doc.save(`Ledger_${customerName}_${ToBritishDate(new Date())}.pdf`);
}